import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { api, imgUrl } from "@/lib/api";
import { CookieBanner } from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import MenuView from "@/pages/MenuView";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentResult from "@/pages/PaymentResult";
import Legal from "@/pages/Legal";

function App() {
  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      if (data.favicon) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = imgUrl(data.favicon);
      }
      if (data.restaurant_name) document.title = data.restaurant_name;
    }).catch(() => {});
  }, []);

  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/carta/:slug" element={<MenuView />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/panel" element={<AdminDashboard />} />
          <Route path="/pago/:result" element={<PaymentResult />} />
          <Route path="/legal/:type" element={<Legal />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
